import { v4 } from 'uuid';
import { Entity } from '../../../../common/ddd/entity.base';
import { MetricValueType } from '../../../../interface/dtos/challenge-insights/metric-value-type';
import { ChallengeTimeInAppsSummaryEntity } from '../../entities/app-summary/challenge-time-in-apps-summary.entity';
import { ChallengeTargetOperatorEnum } from '../../../../common/enum/challenge-target/challenge-target-operator.enum';

export interface ChallengeInsightProgressTimeInAppSummaryAggregateRootProps {
  entity: ChallengeTimeInAppsSummaryEntity;
  currentDayEntity: ChallengeTimeInAppsSummaryEntity;
  targetValue: number;
  type: MetricValueType;
}

export class ChallengeInsightProgressTimeInAppSummaryAggregateRoot extends Entity<ChallengeInsightProgressTimeInAppSummaryAggregateRootProps> {
  protected _id: string;
  protected _successPercentage: number;
  protected _operator: ChallengeTargetOperatorEnum;
  static create(
    props: ChallengeInsightProgressTimeInAppSummaryAggregateRootProps,
    entityId?: string
  ): ChallengeInsightProgressTimeInAppSummaryAggregateRoot {
    const id = entityId || v4();
    const entity = new ChallengeInsightProgressTimeInAppSummaryAggregateRoot({
      id,
      props,
    });
    return entity;
  }
  public validate(): void {}
  get todayValue(): number {
    return this.props.currentDayEntity.value;
  }
  get todayAverage(): number {
    return this.props.currentDayEntity.average;
  }
  get todayAveragePercentage(): number {
    return 100 * this.todayAverage;
  }

  get type(): MetricValueType {
    return this.props.type;
  }
  get count(): number {
    return this.props.entity.count;
  }
  get value(): number {
    return this.props.entity.value;
  }
  get average(): number {
    return this.props.entity.average;
  }
  get targetValue(): number {
    return this.props.targetValue;
  }
  get deviation(): number {
    return this.todayAverage - this.targetValue;
  }
  public setSuccessPercentage(value: number): void {
    this._successPercentage = value;
  }
  get successPercentage(): number {
    return this._successPercentage;
  }
  setChallengeTargetOperator(operator: ChallengeTargetOperatorEnum): void {
    this._operator = operator;
  }
  get projectedSuccess(): boolean {
    return this._operator === ChallengeTargetOperatorEnum.MAX
      ? this.deviation <= 0
      : this.deviation >= 0;
  }
}
